import logo from './logo.svg';
import './App.css';
import Header from './components/Header';
import Projects from './components/Projects';
import Mysite from './components/Mysite';
import Qualifications from './components/Qualifications';
import Littlebit from './components/Littlebit';
import Certificates from './components/Certificates';

import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link
} from "react-router-dom";
function App() {
  return (<div className="App">
    <Router>
    <Switch>
    <Route path="/certificates">
      <Certificates />
    </Route>
    <Route path="/aboutme">
      <Littlebit />
    </Route>
    <Route path="/education">
      <Qualifications />
    </Route>
    <Route path="/projects">
      <Projects />
    </Route>
    <Route path="/mysite">
      <Mysite />
    </Route>
    <Route path="/">
      <Header />
    </Route>
    </Switch>
    </Router>
    </div>
  );
}

export default App;
